import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    startTime: {
      validations: [
        { type: 'required', message: 'Please provide the Event start time.' }
      ]
    },
    endTime: {
      validations: [
        { type: 'required', message: 'Please provide the Event end time.' }
      ]
    },
    operation: {
      validations: []
    },
    theme: {
        validations: []
    },
      siteaddress: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    plannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please enter the number of people.' }
      ]
    },
    reference: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'This field is required.' },
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Client Billing Address:',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'city'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' },
            ],
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'ZIP/Postal Code:',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time:*',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'startTime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time:*',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'endTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:',
            options: [
              {label: 'Baby Naming' , value: 'Baby Naming'},
              {label: 'Baby Shower' , value: 'Baby Shower'},
              {label: 'Banquet' , value: 'Banquet'},
              {label: 'Birthday Party' , value: 'Birthday Party'},
              {label: 'Breakfast' , value: 'Breakfast'},
              {label: 'Bridal Shower' , value: 'Bridal Shower'},
              {label: 'Cocktail Party' , value: 'Cocktail Party'},
              {label: 'Couples Shower' , value: 'Couples Shower'},
              {label: 'Delivery' , value: 'Delivery'},
              {label: 'Dinner Party' , value: 'Dinner Party'},
              {label: 'Engagement Party' , value: 'Engagement Party'},
              {label: 'Fundraiser' , value: 'Fundraiser'},
              {label: 'Funeral Reception' , value: 'Funeral Reception'},
              {label: 'Gala' , value: 'Gala'},
              {label: 'Graduation Party' , value: 'Graduation Party'},
              {label: 'Groundbreaking' , value: 'Groundbreaking'},
              {label: 'Happy Hour' , value: 'Happy Hour'},
              {label: 'Holiday Party' , value: 'Holiday Party'},
              {label: 'Luncheon' , value: 'Luncheon'},
              {label: 'Meeting' , value: 'Meeting'},
              {label: 'Networking Event' , value: 'Networking Event'},
              {label: 'Office Party' , value: 'Office Party'},
              {label: 'Open House' , value: 'Open House'},
              {label: 'Pickup Order' , value: 'Pickup Order'},
              {label: 'Promotional Event' , value: 'Promotional Event'},
              {label: 'Reception' , value: 'Reception'},
              {label: 'Retirement' , value: 'Retirement'},
              {label: 'Seminar' , value: 'Seminar'},
              {label: 'Sip and See' , value: 'Sip and See'},
              {label: 'Wedding Reception' , value: 'Wedding Reception'},
            ],
            mapping: 'operation'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Style of Service:',
            options:[
              {label: 'Seated' , value: 'Seated'},
              {label: 'Buffet' , value: 'Buffet'},
              {label: 'Stations' , value: 'Stations'},
              {label: 'Cocktail Reception' , value: 'Cocktail Reception'},

            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Address:*',
            mapping: 'siteaddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count:*',
            mapping: 'plannedGuestCount'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Who can we thank for your referral?:',
            options:[
              {label: 'The Revaire' , value: 'The Revaire'},
              {label: 'Google' , value: 'Google'},
              {label: 'Instagram' , value: 'Instagram'},
              {label: 'Facebook' , value: 'Facebook'},
              {label: 'Pinterest' , value: 'Pinterest'},
              {label: 'The Venue Report' , value: 'The Venue Report'},
              {label: 'Brides of Houston' , value: 'Brides of Houston'},
              {label: 'Houston Magazine' , value: 'Houston Magazine'},
              {label: 'Papercity Magazine' , value: 'Papercity Magazine'},
              {label: 'Email Marketing' , value: 'Email Marketing'},
              {label: 'Partyslate' , value: 'Partyslate'},
              {label: 'Modern Luxury Weddings' , value: 'Modern Luxury Weddings'},
              {label: 'Other (If you selected "Other", please explain below)' , value: 'Other (If you selected "Other", please explain below)'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Tell us About your Event:*',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'A Fare Extraordinaire Contact Form',
    formId: '2108',
    clientKey: '45F90EA8-99E1-4F7A-8576-3465812DC10C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
